var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import { find } from "./find";
function phoneParser(dialingCodes, inputPhone, countryCode) {
  var phone = inputPhone.replace(/\D|^0{2}/g, "");
  var searchCodes = [phone.substr(0, 4), phone.substr(0, 3), phone.substr(0, 2), phone.substr(0, 1)];
  var foundCode = searchCodes.reduce(function(accumulator, code) {
    if (accumulator) {
      return accumulator;
    }
    var foundItems = code && dialingCodes.filter(function(_ref) {
      var matchingDialingCode = _ref.matchingDialingCode;
      return matchingDialingCode === code;
    }) || null;
    var totalFoundCodes = foundItems && foundItems.length || 0;
    if (totalFoundCodes) {
      return totalFoundCodes === 1 ? (
        // Found item is exactly one
        foundItems[0]
      ) : (
        // Multiple items found. Use countryCode input parameter if set.
        // Othersize pick the one set as dialingDefault, or fallback to first result item
        countryCode && find(foundItems, function(_ref2) {
          var foundItemCode = _ref2.code;
          return foundItemCode.toLowerCase() === countryCode.toLowerCase();
        }) || find(foundItems, function(_ref3) {
          var dialingDefault = _ref3.dialingDefault;
          return dialingDefault;
        }) || foundItems[0]
      );
    }
    return accumulator;
  }, null);
  return foundCode ? {
    countryCode: foundCode.code,
    dialingCode: foundCode.dialingCode,
    phone: phone.substr(foundCode.dialingCode.length)
  } : null;
}
__name(phoneParser, "phoneParser");
export {
  phoneParser
};
